export default __webpack_public_path__ + "static/media/film.71c99426.svg";